export default "__VITE_ASSET__CtT4KIwH__"